import { render, staticRenderFns } from "./games.vue?vue&type=template&id=17e0303e&"
import script from "./games.vue?vue&type=script&lang=js&"
export * from "./games.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports